import { ActionTypes } from '../actions/actionTypes';
import { VisibilityUserSettings } from '../constants/online.homepagegateway.api';

export interface UserSettingsState {
  userSettings: VisibilityUserSettings | null;
  isLoading: boolean;
  error: any;
}

const initialState: UserSettingsState = {
  userSettings: null,
  isLoading: false,
  error: null,
};

export default function userSettingsReducer(state = initialState, action: any): UserSettingsState {
  switch (action.type) {
    case ActionTypes.FETCH_USER_SETTINGS_INIT:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case ActionTypes.FETCH_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userSettings: action.payload,
      };
    case ActionTypes.FETCH_USER_SETTINGS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}